<div *ngIf="isOpen"
    class="fixed inset-0 bg-slate-900/40 backdrop-blur-md z-[60] flex items-center justify-center p-4 transition-opacity duration-300 animate-fade-in"
    (click)="closeModal()">

    <!-- Modal Container -->
    <div (click)="$event.stopPropagation()"
        class="bg-white/95 dark:bg-slate-900/95 w-full max-w-2xl max-h-[90vh] rounded-[24px] shadow-[0_20px_60px_-15px_rgba(0,0,0,0.3)] border border-white/50 dark:border-slate-800/50 flex flex-col overflow-hidden backdrop-blur-xl animate-fade-in-up">

        <!-- Modal Header -->
        <div
            class="flex-none px-5 py-4 border-b border-slate-200/50 dark:border-slate-800/50 flex justify-between items-center bg-transparent gap-4">
            <div>
                <h2
                    class="text-lg md:text-xl font-black text-slate-800 dark:text-white flex items-center gap-3 tracking-tight">
                    <span class="material-icons text-amber-500 text-2xl">add_circle</span>
                    เพิ่มรายการจอดรถ
                    <span [ngClass]="statusType === 'new' ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' : 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400'"
                        class="px-2.5 py-0.5 rounded-full text-xs font-bold uppercase tracking-wider">
                        {{ statusType === 'new' ? 'สมัครใหม่' : 'ต่ออายุ' }}
                    </span>
                </h2>
                <p class="text-sm text-slate-500 dark:text-slate-400 mt-0.5 font-medium">กรอกข้อมูลให้ครบถ้วนเพื่อบันทึกรายการ</p>
            </div>
            <button (click)="closeModal()"
                class="w-10 h-10 flex items-center justify-center rounded-full bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-500 dark:text-slate-400 transition-colors shadow-sm cursor-pointer">
                <span class="material-icons text-xl">close</span>
            </button>
        </div>

        <!-- Modal Body -->
        <div class="flex-1 overflow-y-auto px-5 py-5 bg-slate-50/30 dark:bg-slate-900/30 relative custom-scrollbar space-y-5"
            (click)="closeDropdowns()">

            <!-- Loading State -->
            <div *ngIf="isLoading" class="flex flex-col items-center justify-center py-20 text-slate-400">
                <div class="relative w-16 h-16 mb-4">
                    <div class="absolute inset-0 rounded-full border-4 border-slate-100 dark:border-slate-800"></div>
                    <div class="absolute inset-0 rounded-full border-4 border-transparent border-t-amber-500 animate-spin"></div>
                </div>
                <span class="text-xs font-black uppercase tracking-[0.2em] opacity-60">กำลังโหลดข้อมูล...</span>
            </div>

            <!-- Empty State / Data Missing -->
            <div *ngIf="!isLoading && isDataNotFound" class="flex flex-col items-center justify-center py-16 px-6 text-center animate-fade-in">
                <div class="w-20 h-20 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center mb-6 shadow-inner">
                    <span class="material-icons text-4xl text-slate-300 dark:text-slate-600">inventory_2</span>
                </div>
                <h3 class="text-xl font-black text-slate-700 dark:text-slate-200 mb-2 tracking-tight">ไม่พบข้อมูลที่จำเป็น</h3>
                <p class="text-sm text-slate-500 dark:text-slate-400 max-w-xs mx-auto font-medium">
                    {{ statusType === 'new' ? 'ขออภัย ไม่พบแพ็คเกจที่สมัครได้ในขณะนี้' : 'ขออภัย ไม่พบแพ็คเกจสำหรับต่ออายุในขณะนี้' }}
                </p>
                <div class="mt-8 px-4 py-2 rounded-lg bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-900/30 text-[10px] font-bold text-amber-600 dark:text-amber-400 uppercase tracking-widest leading-relaxed">
                    กรุณาติดต่อผู้ดูแลระบบเพื่อตรวจสอบข้อมูล
                </div>
            </div>

            <!-- Form Content (Only if data is found) -->
            <ng-container *ngIf="!isLoading && !isDataNotFound">
                <!-- LINE OA Selection (optional filter) -->
                <div class="animate-fade-in-up" style="animation-delay: 0.1s;">
                    <label class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
                        สมาชิก LINE OA <span class="text-[10px] font-medium normal-case text-slate-400">(กรองรายการ — ไม่บังคับ)</span>
                    </label>
                    <ng-container *ngTemplateOutlet="selectField; context: { 
                        label: 'สมาชิก LINE OA', 
                        key: 'lines', 
                        options: lineOptions, 
                        selected: selectedLine?.id || selectedLine?.cpUserId, 
                        icon: 'account_circle', 
                        placeholder: '-- ไม่ระบุ --'
                    }"></ng-container>
                </div>

                <!-- Date and Package Grid -->
                <div class="grid grid-cols-1 md:grid-cols-2 gap-5 animate-fade-in-up" style="animation-delay: 0.15s;">
                    <div>
                        <label class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
                            วันเริ่มใช้งาน <span class="text-rose-500">*</span>
                            <span class="text-[10px] lowercase text-slate-400 font-medium" *ngIf="statusType === 'renew' && renewSelectedExpireDate">
                                (ต่อจาก: {{ renewSelectedExpireDate | date: 'dd/MM/yyyy' }}<ng-container *ngIf="renewSelectedCount > 1"> · {{ renewSelectedCount }} บัตร</ng-container>)
                            </span>
                        </label>
                        <div class="relative group">
                            <span class="absolute left-3.5 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-lg group-focus-within:text-amber-500 transition-colors">calendar_month</span>
                            <input type="date" [(ngModel)]="data.memberStartDate"
                                class="w-full pl-11 pr-4 py-2.5 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 rounded-xl focus:ring-4 focus:ring-amber-500/10 focus:border-amber-400 dark:focus:border-amber-500 outline-none transition-all text-slate-700 dark:text-slate-200 text-sm font-bold [color-scheme:light] dark:[color-scheme:dark]">
                        </div>
                    </div>

                    <div>
                        <label class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
                            แพ็คเกจ (Package) <span class="text-rose-500">*</span>
                        </label>
                        <ng-container *ngTemplateOutlet="selectField; context: { 
                            label: 'แพ็คเกจ', 
                            key: 'packages', 
                            options: packageOptions, 
                            selected: selectedSubscriptionId, 
                            icon: 'inventory_2', 
                            placeholder: '-- เลือกแพ็คเกจ --'
                        }"></ng-container>
                    </div>
                </div>

                <!-- Vehicle Section -->
                <div class="bg-white dark:bg-slate-900 rounded-[20px] shadow-sm border border-slate-200/60 dark:border-slate-800 p-4 md:p-5 space-y-4 animate-fade-in-up" style="animation-delay: 0.25s;">
                    <div class="flex justify-between items-center pb-2 border-b border-slate-100 dark:border-slate-800">
                        <h4 class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider flex items-center gap-1.5">
                            <span class="material-icons text-[14px]">directions_car</span>
                            {{ statusType === 'renew' ? 'เลือกทะเบียนที่ต้องการต่ออายุ' : 'ข้อมูลรถ (Vehicle)' }}
                            <span *ngIf="statusType === 'renew'" class="text-[10px] font-medium normal-case text-slate-400">
                                (เลือกได้หลายคัน — LINE OA เดียวกัน)
                            </span>
                        </h4>
                        
                        <button *ngIf="statusType === 'new'" type="button" (click)="openLicenseModal()"
                            [disabled]="!canAddNewLicense"
                            class="text-[11px] font-bold px-2.5 py-1.5 rounded-lg transition-all flex items-center gap-1.5 uppercase tracking-tight"
                            [ngClass]="canAddNewLicense
                                ? 'text-amber-600 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/30 cursor-pointer'
                                : 'text-slate-300 dark:text-slate-600 cursor-not-allowed'">
                            <span class="material-icons text-[14px]">add_circle</span>
                            เพิ่มทะเบียนใหม่
                        </button>
                    </div>

                    <!-- Search Input -->
                    <div class="relative group">
                        <span class="absolute left-3.5 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-lg group-focus-within:text-amber-500 transition-colors">search</span>
                        <input type="text" [(ngModel)]="searchVehicleTerm" placeholder="ค้นหาเลขทะเบียน..."
                            class="w-full pl-11 pr-4 py-2 bg-slate-50 dark:bg-slate-800 border-2 border-slate-100 dark:border-slate-700 rounded-xl focus:ring-4 focus:ring-amber-500/10 focus:border-amber-400 dark:focus:border-amber-500 outline-none transition-all text-slate-700 dark:text-slate-200 text-sm font-medium placeholder:text-slate-400">
                    </div>

                    <!-- Vehicle List -->
                    <div class="max-h-52 overflow-y-auto space-y-2.5 pr-1 custom-scrollbar min-h-[100px]">
                        <div *ngIf="isLoadingVehicles" class="flex flex-col items-center justify-center py-8 text-slate-400">
                            <div class="animate-spin rounded-full h-8 w-8 border-2 border-slate-200 border-t-amber-500 mb-3"></div>
                            <span class="text-xs font-bold uppercase tracking-widest opacity-60">กำลังโหลด...</span>
                        </div>

                        <ng-container *ngIf="!isLoadingVehicles">
                            <div *ngFor="let v of filteredVehicles" (click)="selectVehicle(v)"
                                class="group relative flex items-center gap-4 p-3 rounded-xl border-2 transition-all duration-300 cursor-pointer"
                                [ngClass]="{
                                    'bg-amber-50/50 dark:bg-amber-900/20 border-amber-400 shadow-md shadow-amber-200/20': selectedVehicleId.includes(v.vehicleId),
                                    'bg-white dark:bg-slate-800 border-slate-100 dark:border-slate-700 hover:border-amber-200 dark:hover:border-slate-600': !selectedVehicleId.includes(v.vehicleId)
                                }">

                                <!-- Custom Checkbox -->
                                <div class="w-6 h-6 rounded-lg border-2 flex items-center justify-center transition-all duration-300 flex-shrink-0"
                                    [ngClass]="selectedVehicleId.includes(v.vehicleId)
                                        ? 'bg-amber-500 border-amber-500 shadow-sm shadow-amber-500/25'
                                        : 'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-600 group-hover:border-amber-400'">
                                    <span class="material-icons text-white text-[16px] transition-transform duration-300"
                                        [ngClass]="selectedVehicleId.includes(v.vehicleId) ? 'scale-100' : 'scale-0'">check</span>
                                </div>

                                <div class="flex flex-col">
                                    <span class="text-sm font-black tracking-tight"
                                        [ngClass]="selectedVehicleId.includes(v.vehicleId) ? 'text-amber-800 dark:text-amber-400' : 'text-slate-700 dark:text-slate-200'">
                                        {{ v.plateNumber }}
                                    </span>
                                    <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mt-0.5" *ngIf="v.provinceName">
                                        {{ v.provinceName }}
                                    </span>
                                    <span class="text-[10px] font-medium text-slate-500 dark:text-slate-400 mt-0.5" *ngIf="v.lineFullName">
                                        LINE: {{ v.lineFullName }}
                                    </span>
                                    <span class="text-[10px] font-medium text-blue-500 dark:text-blue-400 mt-0.5" *ngIf="statusType === 'renew' && isRenewVehicle(v)">
                                        {{ v.cardName }} ({{ v.cardCode }}) · หมด {{ v.expireDate | date: 'dd/MM/yyyy' }}
                                    </span>
                                </div>
                            </div>

                            <!-- Empty State (Local list) -->
                            <div *ngIf="filteredVehicles.length === 0"
                                class="flex flex-col items-center justify-center py-10 text-slate-400 bg-slate-50/50 dark:bg-slate-800/30 border-2 border-dashed border-slate-100 dark:border-slate-700 rounded-2xl">
                                <span class="material-icons text-4xl mb-2 opacity-20">no_sim</span>
                                <span class="text-xs font-bold uppercase tracking-widest">ไม่พบข้อมูลทะเบียนรถ</span>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </div>

        <!-- Modal Footer -->
        <div class="flex-none px-6 py-4 bg-white dark:bg-slate-900 border-t border-slate-200/50 dark:border-slate-800/50 flex justify-end gap-3 z-10">
            <button (click)="closeModal()"
                class="px-5 py-2.5 text-sm font-bold text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl transition-all cursor-pointer">
                ยกเลิก
            </button>
            <button *ngIf="!isLoading && !isDataNotFound" (click)="onSave()"
                class="px-8 py-2.5 text-sm font-black bg-amber-400 hover:bg-amber-500 text-amber-900 rounded-xl shadow-lg shadow-amber-400/30 transition-all transform hover:-translate-y-0.5 cursor-pointer active:translate-y-0 uppercase tracking-wider animate-fade-in-up">
                ยืนยันการเพิ่ม
            </button>
        </div>
    </div>
</div>

<!-- License Modal -->
<app-modal-license-add *ngIf="isLicenseModalOpen" [cpUserId]="licenseModalCpUserId"
    [vehicleTypeId]="vehicleTypeId" (close)="isLicenseModalOpen = false" (save)="onLicenseAdded()">
</app-modal-license-add>

<!-- REUSABLE DROPDOWN TEMPLATE -->
<ng-template #selectField let-label="label" let-key="key" let-options="options" let-selected="selected" let-icon="icon"
    let-placeholder="placeholder" let-disabled="disabled">
    <div class="relative w-full" (click)="$event.stopPropagation()">
        <!-- Selected Value Display -->
        <button type="button" (click)="!disabled && toggleDropdown(key, $event)" [disabled]="disabled"
            class="w-full flex items-center justify-between px-4 py-2.5 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 rounded-xl outline-none transition-all duration-200 group relative"
            [ngClass]="{
                'ring-4 ring-amber-500/10 border-amber-400 dark:border-amber-500 shadow-sm': openDropdown === key,
                'hover:border-amber-300 dark:hover:border-amber-500/50': !disabled && openDropdown !== key,
                'opacity-60 cursor-not-allowed bg-slate-50 dark:bg-slate-900/50': disabled,
                'cursor-pointer': !disabled
            }">

            <div class="flex items-center gap-3 overflow-hidden mr-6">
                <!-- Icon mapping logic can be enhanced if needed -->
                <span class="material-icons text-[20px] transition-colors duration-300"
                      [ngClass]="selected ? 'text-amber-500' : 'text-slate-400 group-hover:text-amber-400'">
                    {{ icon }}
                </span>
                <span class="text-sm font-bold truncate tracking-tight"
                    [ngClass]="selected ? 'text-slate-800 dark:text-slate-100' : 'text-slate-400'">
                    {{ getOptionName(key, selected) || placeholder }}
                </span>
            </div>

            <!-- Arrow Icon -->
            <span class="material-icons text-[20px] text-slate-400 transition-transform duration-300 absolute right-3"
                [ngClass]="{ 'rotate-180 text-amber-500': openDropdown === key }">
                expand_more
            </span>
        </button>

        <!-- Dropdown Options Menu -->
        <div *ngIf="openDropdown === key && !disabled"
            class="absolute z-[100] mt-2 w-full bg-white dark:bg-slate-800 rounded-2xl shadow-[0_15px_50px_-10px_rgba(0,0,0,0.25)] border border-slate-100 dark:border-slate-700/80 py-2 animate-fade-in divide-y divide-slate-50 dark:divide-slate-700/50 max-h-60 overflow-y-auto custom-scrollbar">

            <div *ngIf="options.length === 0" class="px-4 py-10 text-center opacity-40">
                <span class="material-icons text-3xl mb-2">inventory_2</span>
                <p class="text-[11px] font-bold uppercase tracking-widest">ไม่มีข้อมูล</p>
            </div>

            <button *ngFor="let opt of options" type="button" (click)="selectOption(key, opt.value)"
                class="w-full flex items-center justify-between px-4 py-3 hover:bg-amber-50 dark:hover:bg-amber-900/20 text-left transition-all group">
                <span class="text-[13px] font-bold transition-colors"
                    [ngClass]="selected === opt.value ? 'text-amber-600 dark:text-amber-400' : 'text-slate-600 dark:text-slate-300 group-hover:text-amber-600'">
                    {{ opt.label }}
                </span>
                <div *ngIf="selected === opt.value" class="w-5 h-5 rounded-full bg-amber-500 flex items-center justify-center shadow-sm animate-scale-up">
                    <span class="material-icons text-white text-[12px]">check</span>
                </div>
            </button>
        </div>
    </div>
</ng-template>